module.exports = __webpack_public_path__ + "static/media/crm.354ad6cf.png";